export const Types = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    LOGOUT: 'USERS_LOGOUT',

};

export const alertConstants = {
    REQUEST: 'ALERT_REQUEST',
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    CLEAR: 'ALERT_CLEAR',
};
export const getConstants = {
    GET_ALL_REQUEST: 'GET_ALL_REQUEST',
    GET_ALL_SUCCESS: 'GET_ALL_SUCCESS',
    GET_ALL_FAILURE: 'GET_ALL_FAILURE',

    GET_PARTICULAR_REQUEST: 'GET_PARTICULAR_REQUEST',
    GET_PARTICULAR_SUCCESS: 'GET_PARTICULAR_SUCCESS',
    GET_PARTICULAR_FAILURE: 'GET_PARTICULAR_FAILURE',

    GET_DISTRIBUTORS_LIST_REQUEST: 'GET_DISTRIBUTORS_LIST_REQUEST',
    GET_DISTRIBUTORS_LIST_SUCCESS: 'GET_DISTRIBUTORS_LIST_SUCCESS',
    GET_DISTRIBUTORS_LIST_FAILURE: 'GET_DISTRIBUTORS_LIST_FAILURE',

    CREATE_DISTRIBUTORS_REQUEST: 'CREATE_DISTRIBUTORS_REQUEST',
    CREATE_DISTRIBUTORS_SUCCESS: 'CREATE_DISTRIBUTORS_SUCCESS',
    CREATE_DISTRIBUTORS_FAILURE: 'CREATE_DISTRIBUTORS_FAILURE',

    CREATE_REQUEST: 'CREATE_REQUEST',
    CREATE_SUCCESS: 'CREATE_SUCCESS',
    CREATE_FAILURE: 'CREATE_FAILURE',

    UPDATE_REQUEST: 'CREATE_REQUEST',
    UPDATE_SUCCESS: 'CREATE_SUCCESS',
    UPDATE_FAILURE: 'CREATE_FAILURE',

    GET_ALL_USER_REQUEST: 'GET_ALL_USER_REQUEST',
    GET_ALL_USER_SUCCESS: 'GET_ALL_USER_SUCCESS',
    GET_ALL_USER_FAILURE: 'GET_ALL_USER_FAILURE',

    GET_PARTNER_LIST_REQUEST: 'GET_PARTNER_LIST_REQUEST',
    GET_PARTNER_LIST_SUCCESS: 'GET_PARTNER_LIST_SUCCESS',
    GET_PARTNER_LIST_FAILURE: 'GET_PARTNER_LIST_FAILURE',

    ACCEPT_PARTNER_REQUEST: 'ACCEPT_PARTNER_REQUEST',
    ACCEPT_PARTNER_SUCCESS: 'ACCEPT_PARTNER_SUCCESS',
    ACCEPT_PARTNER_FAILURE: 'ACCEPT_PARTNER_FAILURE',

    REJECT_PARTNER_REQUEST: 'REJECT_PARTNER_REQUEST',
    REJECT_PARTNER_SUCCESS: 'REJECT_PARTNER_SUCCESS',
    REJECT_PARTNER_FAILURE: 'REJECT_PARTNER_FAILURE',
    
    PROFILE_REQUEST: 'PROFILE_REQUEST',
    PROFILE_SUCCESS: 'PROFILE_SUCCESS',
    PROFILE_FAILURE: 'PROFILE_FAILURE',

    ADD_PAGINATION: 'ADD_PAGINATION',
    REMOVE_PAGINATION: 'REMOVE_PAGINATION',

};
export const ProductConstants ={ 
    GET_PRODUCTS_LIST_REQUEST: 'GET_PRODUCTS_LIST_REQUEST',
    GET_PRODUCTS_LIST_SUCCESS: 'GET_PRODUCTS_LIST_SUCCESS',
    GET_PRODUCTS_LIST_FAILURE: 'GET_PRODUCTS_LIST_FAILURE',

    GET_PRODUCTS_FILTERS_SUCCESS: 'GET_PRODUCTS_FILTERS_SUCCESS',
    
    GET_WISHLIST_LIST_REQUEST: 'GET_WISHLIST_LIST_REQUEST',
    GET_WISHLIST_LIST_SUCCESS: 'GET_WISHLIST_LIST_SUCCESS',
    GET_WISHLIST_LIST_FAILURE: 'GET_WISHLIST_LIST_FAILURE',
    
    GET_WISHLIST_SELECTED_ITEM: 'GET_WISHLIST_SELECTED_ITEM',

    GET_CART_LIST_REQUEST: 'GET_CART_LIST_REQUEST',
    GET_CART_LIST_SUCCESS: 'GET_CART_LIST_SUCCESS',
    GET_CART_LIST_FAILURE: 'GET_CART_LIST_FAILURE',

    ADD_TO_CART_REQUEST: 'ADD_TO_CART_REQUEST',
    ADD_TO_CART_SUCCESS: 'ADD_TO_CART_SUCCESS',
    ADD_TO_CART_FAILURE: 'ADD_TO_CART_FAILURE',

    CART_CALCULATION_REQUEST: 'CART_CALCULATION_REQUEST',
    CART_CALCULATION_SUCCESS: 'CART_CALCULATION_SUCCESS',
    CART_CALCULATION_FAILURE: 'CART_CALCULATION_FAILURE',

    OFFER_DETAILS_REQUEST: 'OFFER_DETAILS_REQUEST',
    OFFER_DETAILS_SUCCESS: 'OFFER_DETAILS_SUCCESS',
    OFFER_DETAILS_FAILURE: 'OFFER_DETAILS_FAILURE',

    BULK_OFFER_DETAILS_REQUEST: 'BULK_OFFER_DETAILS_REQUEST',
    BULK_OFFER_DETAILS_SUCCESS: 'BULK_OFFER_DETAILS_SUCCESS',
    BULK_OFFER_DETAILS_FAILURE: 'BULK_OFFER_DETAILS_FAILURE',

    OFFER_DATA_REQUEST: 'OFFER_DATA_REQUEST',
    OFFER_DATA_SUCCESS: 'OFFER_DATA_SUCCESS',
    OFFER_DATA_FAILURE: 'OFFER_DATA_FAILURE',



}
export const OrderConstants ={ 
    GET_ORDER_DETAILS_REQUEST: 'GET_ORDER_DETAILS_REQUEST',
    GET_ORDER_DETAILS_SUCCESS: 'GET_ORDER_DETAILS_SUCCESS',
    GET_ORDER_DETAILS_FAILURE: 'GET_ORDER_DETAILS_FAILURE',
}